import { isEmpty } from "lodash";
import { createPortal } from "react-dom";
export function ModalPortal(props) {
    var portalContainer = document.getElementById("modal-container");
    if (isEmpty(portalContainer)) {
        throw new Error("Unable to find modal portal container.");
    }
    return createPortal(props.children, portalContainer);
}
